// src/utils/i18messages/index.js
import en from "./en";
import id from "./id";

const messages = {
  en,
  id,
};

export const getmessage = (key) => {
  const language = localStorage.getItem("i18nextLng") || "en";
  const langMessages = messages[language] || messages.en;

  const keys = key.split(".");
  let value = langMessages;

  for (const k of keys) {
    if (value[k] === undefined) {
      return key; // fallback jika key tidak ditemukan
    }
    value = value[k];
  }

  return value;
};
